const Slider = {}
export default Slider;
